<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="入库批次">
            <a-input
              v-decorator="['operation_no', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="精确查询"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8" :xxl="6">
          <a-form-item label="供应商">
            <a-select
              v-decorator="['profile_supplier_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              :loading="loadingSupplierOptions"
            >
              <a-select-option v-for="opt in supplierOptions" :key="opt.id" :value="opt.id">
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8" :xxl="6">
          <a-form-item label="入库日期">
            <a-range-picker
              v-decorator="['operation_date_range']"
              style="width: 100%"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">搜索</a-button>
              <a-button @click="handleReset">刷新</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findProfileSuppliers } from '@/api/profile_supplier'

export default {
  name: 'SearchProfileInventoryImportRecords',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'profile_inventory_import_records_search' }),
      supplierOptions: [],
      loadingSupplierOptions: false
    }
  },
  created() {
    this.loadingSupplierOptions = true
    findProfileSuppliers({ page: 1, per_page: 500 }).then((res) => {
      if (res.code === 0) this.supplierOptions = res.data
      this.loadingSupplierOptions = false
    })
  },
  methods: {
    handleSearch(e) {
      e.preventDefault()
      const v = this.form.getFieldsValue()
      const range = v.operation_date_range || []
      this.$emit('submit', {
        operation_no: v.operation_no,
        profile_supplier_id: v.profile_supplier_id,
        operation_date_begin: range[0],
        operation_date_end: range[1]
      })
    },
    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
